<template>
    <div class="container-fluid py-2">
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="pb-0 card-header">
              <div class="d-lg-flex">
                <div>
                  <h5 class="mb-0">
                    Clientes({{ clientesFiltered.length }})
                  </h5>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row mb-4">
                <div class="col-md-12">
                  <label>Pesquisar Cliente</label>
                  <input class="form-control text-uppercase" v-model="search" placeholder="Nome Fantasia, CPF/CNPJ">
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 col-sm-12" v-for="cliente of clientesFiltered" :key="cliente.id">
                  <cliente-card :cliente="cliente" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ClienteCard from './components/ClienteCard.vue'
  import api from '@/services/api'
  
  export default {
    name: "ClientesFreemium",
    components: {
      ClienteCard,
    },
    data() {
      return {
        clientes: [],
        clientesFiltered: [],
        search: '',
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        this.loading = true;
  
        api.get(`/clientes-freemium`)
          .then(response => {
            const { data } = response;

            this.clientes = data;
            this.filterClientes();
          })
          .catch(e => console.log(e));
      },
      filterClientes() {
        const { search } = this;

        let items = [...this.clientes];

        if (search) {
          items = items.filter(item => {
            const { nome_fantasia, documento, razao_social } = item;
            const searchLower = search.toLowerCase();
            return razao_social.toLowerCase().includes(searchLower) || nome_fantasia.toLowerCase().includes(searchLower) || documento.includes(searchLower);
          });
        }

        this.clientesFiltered = items;
      },
    },
    watch: {
      search: function () {
        this.filterClientes();
      },
    }
  };
  </script>
  <style lang="scss">
  .btn {
    margin-bottom: 0 !important;
  }
  </style>
  